/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_Method_StrengthInputs */

const en_us2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const pt_br2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const es_419_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza`)
};

const pt_pt2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força`)
};

const fr_fr2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force`)
};

const de_de2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft`)
};

const it_it2_workout_logging_warmup_method_strength = /** @type {(inputs: Workout_Logging_Warmup_Method_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Workout_Logging_Warmup_Method_StrengthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_method_strength = /** @type {((inputs?: Workout_Logging_Warmup_Method_StrengthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_Method_StrengthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_method_strength(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_method_strength(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_method_strength(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_method_strength(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_method_strength(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_method_strength(inputs)
	return en_us2_workout_logging_warmup_method_strength(inputs)
});
export { workout_logging_warmup_method_strength as "workout-logging.warmup_method_strength" }